export function enumToObject<T extends { [key: string]: string | number }>(enumObj: T): { [K in keyof T]: T[K] } {
  return Object.fromEntries(Object.entries(enumObj).filter(([key]) => isNaN(Number(key)))) as { [K in keyof T]: T[K] }
}
